// extracted by mini-css-extract-plugin
export var cardHeader = "_sc-0";
export var reorderHandle = "_sc-3";
export var titleArea = "_sc-1";
export var titleAreaWithHandle = "_sc-2";